/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsquerySalesarticlesHighlightedGet$Params {
}

export function apiProductsquerySalesarticlesHighlightedGet(http: HttpClient, rootUrl: string, params?: ApiProductsquerySalesarticlesHighlightedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsquerySalesarticlesHighlightedGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSummary>>;
    })
  );
}

apiProductsquerySalesarticlesHighlightedGet.PATH = '/api/productsquery/salesarticles/highlighted';
